import IDataNotFound from "../../shared/interfaces/data-not-found.interface";


export const DATA_NOT_FOUND: IDataNotFound = {
    title: "Ups! Sin datos",
    description: "No hay reservas para este día, intenta con otro filtro."
};